<pp-table
  class="exchange-table"
  gridTemplateColumns="2fr 1fr 1fr 1fr"
  [dataSource]="cryptoMarketSignal()"
  [columns]="columns()"
  [filters]="cryptoMarketFilter$() | async"
  (sortEvent)="onSortChange()">
  <ng-template let-market>
    <section class="table-body">
      <div class="name">
        <img
          width="20"
          height="20"
          alt="Image"
          [src]="market.coinCurrency.image.url" />
        <span class="pp-white">{{ market.coinCurrency.code }} </span>
        <span class="pp-gray">{{ market.coinCurrency.name }}</span>
      </div>
      <div class="justify-end pp-gray">
        <span>{{
          market.price | toCurrency: market.priceCurrency.unicode
        }}</span>
      </div>
      <div class="justify-end change-time pp-gray">
        <span
          [class.increase]="
            market.changeTime.changeType === changeType.increase
          "
          [class.decrease]="
            market.changeTime.changeType === changeType.decrease
          ">
          {{ market.changeTime.changeType === changeType.increase ? '+' : '-' }}
          {{ market.changeTime.percents }}%
        </span>
        <pu-icon
          [iconName]="
            market.changeTime.changeType === changeType.increase
              ? 'income'
              : 'expense'
          "
          size="16" />
      </div>
      <div class="justify-end pp-gray">
        <span>{{
          market.marketCap | toShortMetric: market.priceCurrency.unicode
        }}</span>
      </div>
    </section>
  </ng-template>
</pp-table>
